"use strict";
import { Action } from "../actions";
export default function addingComponentReducer(addingComponent = {}, action) {
  switch (action.type) {
    case Action.ADDING_START: {
      const { coords, typeID, guid } = action;
      return {
        guid,
        typeID,
        start: coords
      };
    }
    case Action.ADDING_FINISH: {
      return {};
    }
    default:
      return addingComponent;
  }
}
